import React, { useState } from "react";
import "../styles/toolbar-button.css";
export const ToolbarButton = ({ onClick, isActive = false, title, children, disabled = false, panel }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    return (React.createElement("div", { className: "cwb__toolbar__button__wrapper", style: { position: 'relative' } },
        React.createElement("button", { className: ['cwb__toolbar__button', isActive && 'active'].filter(Boolean).join(" "), onClick: onClick, disabled: disabled, type: "button", onMouseEnter: () => setShowTooltip(true), onMouseLeave: () => setShowTooltip(false) }, children),
        showTooltip && title && (React.createElement("div", { className: "cwb__toolbar__tooltip" },
            title,
            React.createElement("div", { className: "cwb__toolbar__tooltip__arrow" }))),
        panel && panel.show && (React.createElement("div", { className: "cwb__toolbar__button__panel" }, panel.content))));
};
